var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarThing2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 80,
    viewBox: "0 0 62 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 1.9375C31 1.9375 31.5155 21.7978 39.3728 30.2215C46.0137 37.341 62 40.6875 62 40.6875C62 40.6875 46.0137 44.034 39.3728 51.1535C31.5155 59.5772 31 79.4375 31 79.4375C31 79.4375 30.4845 59.5772 22.6272 51.1535C15.9863 44.034 0 40.6875 0 40.6875C0 40.6875 15.9863 37.341 22.6272 30.2215C30.4845 21.7978 31 1.9375 31 1.9375Z",
    fill: "#FE3176"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0C31 0 31.5155 19.8603 39.3728 28.284C46.0137 35.4035 62 38.75 62 38.75C62 38.75 46.0137 42.0965 39.3728 49.216C31.5155 57.6397 31 77.5 31 77.5C31 77.5 30.4845 57.6397 22.6272 49.216C15.9863 42.0965 0 38.75 0 38.75C0 38.75 15.9863 35.4035 22.6272 28.284C30.4845 19.8603 31 0 31 0Z",
    fill: "#15BCFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarThing2);
export default __webpack_public_path__ + "static/media/star_thing_2.1c443597.svg";
export { ForwardRef as ReactComponent };